import { parse } from 'url';

import { Component } from 'react';
import PropTypes from 'prop-types';

import type { RoutesContextType } from './RoutesContext';
import { withRoutesContext } from './withRoutesContext';

type RedirectionProps = {
	href?: string;
	name?: string;
	params?: Parameters<RoutesContextType['toUrl']>[1];
	to?: string;
	usePush?: boolean;
	forceReload?: Parameters<RoutesContextType['push']>[1];
};

export const Redirection = withRoutesContext(
	class Redirection extends Component<RedirectionProps & RoutesContextType> {
		static propTypes = {
			href: PropTypes.string,
			name: PropTypes.string,
			params: PropTypes.object,
			to: PropTypes.string,
			usePush: PropTypes.bool,

			push: PropTypes.func.isRequired,
			replace: PropTypes.func.isRequired,
			toUrl: PropTypes.func.isRequired,

			forceReload: PropTypes.bool,
		};

		UNSAFE_componentWillMount() {
			if (process.env.REACT_SSR) {
				// This instructs cc-frontend-ssr to throw away the SSR output and write an HTML meta redirect instead
				window['__SSR_REDIRECT__'] = this.getUrl();
			}
		}

		componentDidMount() {
			const { usePush = false, push, replace, forceReload = false } = this.props;

			(usePush ? push : replace)(this.getUrl(), forceReload);
		}

		getUrl() {
			const { name, params, href = null, to = null, toUrl, getQueryParams, getHash } = this.props;

			const customPath = href || to;

			let parsedUrl = {};
			if (customPath) {
				parsedUrl = parse(customPath, true);
			}

			return toUrl(name, {
				hash: getHash(),
				query: getQueryParams(),
				...params,
				...parsedUrl,
			});
		}

		render() {
			return null;
		}
	},
);
